import React, { useState } from "react";

import { ERRORED_CLASSNAME } from "@impero-com/common/utils/form/erroredElements";
import { t } from "@impero-com/common/utils/i18n";
import {
    getAbbreviatedTimezoneName,
    TimezoneKey,
} from "@impero-com/common/utils/timezone";
import { Button, FormField, FormLabel, Modal } from "@impero-com/ui";
import { cx } from "class-variance-authority";

import { TimezoneTypeahead } from "components/timezoneTypeahead/timezoneTypeahead";

export type TimezoneTypeaheadValue = TimezoneKey | undefined;
interface TimezoneTypeaheadInputProps {
    label?: React.ReactNode;
    disabled?: boolean;
    value: TimezoneTypeaheadValue;
    error?: string;
    onChange: (timezoneName: string) => void;
    onBlur: () => void;
    fieldRef?: React.RefCallback<HTMLElement>;
}
export function TimezoneTypeaheadPopupInput({
    label,
    value,
    error,
    onChange,
    onBlur,
    fieldRef,
    disabled = false,
}: TimezoneTypeaheadInputProps) {
    const [dialogOpen, setDialogOpen] = useState(false);

    const handleOk = () => {
        setDialogOpen(false);
        onBlur?.();
    };
    const handleCancel = () => {
        setDialogOpen(false);
    };

    const displayValue = value
        ? getAbbreviatedTimezoneName(value)
        : t("TimezoneSelector_Title");

    return (
        <FormField
            error={error}
            className={cx(error && ERRORED_CLASSNAME)}
            lite={label === undefined}
        >
            {label && <FormLabel disabled={disabled}>{label}</FormLabel>}
            <Button
                id="timezone-button"
                variant="link"
                onClick={() => setDialogOpen(true)}
                disabled={disabled}
                ref={fieldRef}
            >
                {displayValue}
            </Button>
            {!disabled && (
                <Modal
                    variant="content"
                    open={dialogOpen}
                    onClose={handleCancel}
                    title={t("TimezoneSelector_Title")}
                    footer={
                        <>
                            <Button onClick={handleCancel}>
                                {t("Cancel")}
                            </Button>
                            <Button variant="primary" onClick={handleOk}>
                                {t("Apply")}
                            </Button>
                        </>
                    }
                >
                    <FormLabel>{t("Timezone")}</FormLabel>
                    <TimezoneTypeahead
                        id="timezones-selector"
                        value={value}
                        onSelect={onChange}
                    />
                </Modal>
            )}
        </FormField>
    );
}
